import axios from 'axios';

// Client HTTP des pages d'administration : joint le jeton admin à chaque appel.
const adminApi = axios.create();

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_jwt');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Jeton absent, expiré ou refusé : retour à la page de connexion.
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('admin_jwt');
      window.location.assign('/gestion-x7k9p2/login');
    }
    return Promise.reject(error);
  }
);

export default adminApi;
